import { Box, useMantineTheme } from '@mantine/core';
import { type FC, type PropsWithChildren } from 'react';
import { ACTION_BAR_HEIGHT } from './constants';

export const ActionBar: FC<PropsWithChildren> = ({ children }) => {
    const theme = useMantineTheme();

    return (
        <Box
            component="header"
            style={{
                height: ACTION_BAR_HEIGHT,
                borderBottom: `1px solid ${theme.colors.gray[3]}`,
                display: 'flex',
                alignItems: 'center',
                paddingLeft: theme.spacing.lg,
                paddingRight: theme.spacing.lg,
                backgroundColor: theme.white,
                flexShrink: 0,
            }}
        >
            {children}
        </Box>
    );
};
